import { useCallback, useRef, useState } from "react";

// Ochrana proti dvojkliku na ukládací tlačítko. Bez ní vznikne z jednoho
// dvojkliku několik POSTů — tedy duplicitní úkol, platba, komentář…
//
// Zámek drží useRef, ne state: ref se nastaví synchronně, takže druhý klik
// ve stejném tiku (než React stihne přerenderovat) neprojde. Vrácený `busy`
// slouží jen k zobrazení (disabled tlačítko, text „Ukládám…").
//
//   const [busy, guard] = useSubmitGuard();
//   <Button onClick={() => guard(submit)} disabled={busy}>Uložit</Button>
export function useSubmitGuard() {
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);

  const guard = useCallback(async (fn) => {
    if (lock.current) return;
    lock.current = true;
    setBusy(true);
    try {
      return await fn();
    } finally {
      lock.current = false;
      setBusy(false);
    }
  }, []);

  return [busy, guard];
}
